import { HaloEffect } from "./halo";
import { HaloParticlesEffect } from "./halo-particles";
import { NoneEffect } from "./none";
import type { NoteEffectFactory, NoteEffectStyle } from "./types";

const REGISTRY: Record<NoteEffectStyle, NoteEffectFactory> = {
  "halo-particles": (parent) => new HaloParticlesEffect(parent),
  "halo": (parent) => new HaloEffect(parent),
  "none": (parent) => new NoneEffect(parent),
};

export function createNoteEffect(
  style: NoteEffectStyle,
  parent: import("pixi.js").Container,
) {
  return REGISTRY[style](parent);
}
